import React from 'react';

export default class TicketStubContent extends React.Component {
  static propTypes = {
    children: React.PropTypes.node,
    dataComponent: React.PropTypes.string
  };

  render () {
    return (
      <div className="ticket_stub_content" data-component={this.props.dataComponent}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/content.js